export default "__VITE_ASSET__eMy8rn$H__"